import React, { useState, useEffect } from "react";
import { Form, Input, Button, Select, Upload } from "antd";
import { InboxOutlined } from "@ant-design/icons";
import { getGlobalVar, setGlobalVar } from "../../config/Config"; // added a new branch
import axios from "axios";

const { Dragger } = Upload;
const { Option } = Select;

const Customer = ({
  setCustomerToggle,
  customerData,
  setCurrentCustomer,
  setCustomerData,
  onCustomerClick,
}) => {
  const [addcustomer, setAddCustomer] = useState(false);
  const globalVar = getGlobalVar();
  const baseurl = globalVar.url;
  const USER = JSON.parse(localStorage.getItem("auth"));
  const org = "?org=" + USER.org;
  const customersAPI = baseurl + "/crmapi/GetClient/" + org;
  const [loading, setLoading] = useState(false);

  const onCustomerClickHandler = (id) => {
    setCustomerToggle(false);
    setCurrentCustomer(customerData.find((customer) => customer.id === id));
    onCustomerClick(id);
  };
  const addCustomer = () => {
    setAddCustomer(true);
  };
  const [form] = Form.useForm();

  const handleSubmit = async (values) => {
    setLoading(true);
    console.log("Form Values:", values.logo.file);
    const formData = new FormData();
    
    Object.keys(values).forEach((key) => {
      if (key === "logo" && values.logo) {
        formData.append(key, values.logo[0].originFileObj);
      } else {
        formData.append(key, values[key]);
      }
    });
    formData.append("org", USER.org);
    try {
      const response = await axios.post(`${customersAPI}`, formData, {
        headers: {
          Authorization: "Token " + globalVar.Token,
        },
      });
      setCustomerData([...customerData, response.data]);
      setLoading(false);

      setAddCustomer(false);
    } catch (error) {
      console.error("Error submitting form:", error);
      alert("Failed to submit form. Please try again.");
      setLoading(false);
    }
  };
  return (
    <>
      <div className=" pay-popup p-4">
        <div className="row">
          <div className="col-12  ">
            <div className="cancel-validate flex justify-between bg-gray-300">
              <Button
                variant="danger"
                onClick={() => {
                  setCustomerToggle(false);
                }}
              >
                Close
              </Button>
              <Button className="xb" variant="success" onClick={addCustomer}>
                Add Customer
              </Button>
            </div>
          </div>
        </div>
        <div className="row mt-4">
          <div
            className="col-12 "
            style={{ height: "calc(100vh - 100px)", overflow: "scroll" }}
          >
            <table className="table-auto w-full text-left">
              <thead className="bg-gray-200">
                <tr>
                  <th className="px-4 py-2">ID</th>
                  <th className="px-4 py-2">Name</th>
                  <th className="px-4 py-2">Address</th>
                  <th className="px-4 py-2">Phone</th>
                  <th className="px-4 py-2">Email</th>
                  <th className="px-4 py-2">Actions</th>
                </tr>
              </thead>
              <tbody>
                {customerData.length > 0 ? (
                  customerData.map((customer) => (
                    <tr
                      key={customer.id}
                      className="border-t customer-data-list"
                    >
                      {/* ID */}
                      <td className="px-4 py-2">{customer.id}</td>

                      {/* Name */}
                      <td className="px-4 py-2">{customer.Name}</td>

                      {/* Address (combined Street1 + Street2 + City + Zip + Country) */}
                      <td className="px-4 py-2">
                        {[
                          customer.Street1,
                          customer.Street2,
                          customer.City,
                          customer.Zip,
                          customer.Country,
                        ]
                          .filter(Boolean)
                          .join(", ")}
                      </td>

                      {/* Phone */}
                      <td className="px-4 py-2">{customer.Phone}</td>

                      {/* Email */}
                      <td className="px-4 py-2">{customer.Email}</td>
                      <td className="px-4 py-2">
                        <button
                          className=" xb btn btn-success text-white  px-4 py-2"
                          onClick={() => onCustomerClickHandler(customer.id)}
                        >
                          Select
                        </button>
                      </td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan="6" className="text-center py-4">
                      No customers found
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
        </div>
      </div>
      {addcustomer ? (
        <div className=" pay-popup p-4">
          <div className="row">
            <div className="col-12 ">
              <div className="cancel-validate flex justify-between bg-gray-300">
                <Button
                  variant="danger"
                  onClick={() => {
                    setAddCustomer(false);
                  }}
                >
                  Close
                </Button>
              </div>
            </div>
          </div>
          <div className="row mt-4">
            <div
              className="col-12 "
              style={{ height: "calc(100vh - 100px)", overflow: "scroll" }}
            >
              <div style={{ maxWidth: 800, margin: "50px auto" }}>
                <h1>Customer</h1>
                <Form
                  form={form}
                  layout="vertical"
                  onFinish={handleSubmit}
                  initialValues={{
                    name: "Defcon Innovations",
                    address: "rambagh srinagar \nKashmir",
                    phone: "8491992778",
                    email: "defconinnovations@gmail.com",
                    country: "India",
                  }}
                >
                  <div className="row">
                    <div className="col-md-6">
                      <Form.Item
                        label="Name"
                        name="name"
                        rules={[
                          { required: true, message: "Please enter the name" },
                        ]}
                      >
                        <Input />
                      </Form.Item>

                      <Form.Item
                        label="Phone"
                        name="phone"
                        rules={[
                          {
                            required: true,
                            message: "Please enter the phone number",
                          },
                        ]}
                      >
                        <Input />
                      </Form.Item>
                      <Form.Item
                        label="Email"
                        name="email"
                        rules={[
                          {
                            required: true,
                            type: "email",
                            message: "Please enter a valid email",
                          },
                        ]}
                      >
                        <Input />
                      </Form.Item>

                      <Form.Item
                        label="Country"
                        name="country"
                        rules={[
                          {
                            required: true,
                            message: "Please select a country",
                          },
                        ]}
                      >
                        <Select>
                          <Option value="India">India</Option>
                          <Option value="USA">USA</Option>
                          <Option value="UK">UK</Option>
                          <Option value="Canada">Canada</Option>
                        </Select>
                      </Form.Item>
                    </div>

                    <div className="col-md-6">
                      <Form.Item
                        label="Address"
                        name="address"
                        rules={[
                          {
                            required: true,
                            message: "Please enter the address",
                          },
                        ]}
                      >
                        <Input.TextArea rows={3} />
                      </Form.Item>
                      <Form.Item
                        label="Logo"
                        name="logo"
                        valuePropName="fileList"
                        getValueFromEvent={(e) => {
                          return Array.isArray(e) ? e : e && e.fileList;
                        }}
                        rules={[
                          { required: true, message: "Please upload the logo" },
                        ]}
                      >
                        <Dragger name="files" beforeUpload={() => false}>
                          <p className="ant-upload-drag-icon">
                            <InboxOutlined />
                          </p>
                          <p className="ant-upload-text">
                            Click or drag file to this area to upload
                          </p>
                        </Dragger>
                      </Form.Item>
                    </div>
                  </div>

                  <Form.Item>
                    <Button
                      type="primary"
                      htmlType="submit"
                      className="xb"
                      variant="success"
                      loading={loading}
                    >
                      Submit
                    </Button>
                  </Form.Item>
                </Form>
              </div>
            </div>
          </div>
        </div>
      ) : (
        ""
      )}
    </>
  );
};
export default Customer;
